"use client";

import React from "react";
import { Apple, Play, Smartphone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToCharge() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const iosLink = "https://apps.apple.com/app/zapgo";
  const androidLink = "https://play.google.com/store/apps/details?id=zapgo.app";
  return <section id="klaar-om-te-laden" className="relative overflow-hidden bg-background py-24 lg:py-32" ref={sectionRef}>
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <div className="aspect-square w-[80vw] max-w-[800px] rounded-full bg-primary/15 blur-[100px] lg:bg-primary/20 lg:blur-[150px]" />
      </div>

      <div className="container relative z-10 mx-auto px-4">
        {}
        <div className={`mx-auto max-w-2xl text-center transition-all duration-1000 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <h2 className="mb-6 text-4xl font-bold tracking-tight text-foreground sm:text-5xl lg:text-6xl">
            Klaar om te <span className="text-primary">Laden?</span>
          </h2>
          <p className="mb-12 text-lg text-muted-foreground sm:text-xl">
            Download de <span className="text-[#ffe838]">Zap</span><span className="text-[#70cf70]">GO!</span> app, vind direct een laadstation bij jou in de
            buurt en kom nooit meer met een lege batterij te zitten.
          </p>
        </div>

        {}
        <div className="mx-auto mt-12 flex max-w-5xl flex-col items-center justify-center gap-12 lg:flex-row lg:gap-16">
          {}
          <div className={`order-2 flex w-full justify-center lg:order-1 lg:w-auto lg:justify-end transition-all duration-1000 delay-200 ${isVisible ? "translate-x-0 opacity-100" : "-translate-x-10 opacity-0"}`}>
            <Button asChild size="lg" className="h-16 w-full max-w-[280px] rounded-2xl bg-foreground text-background hover:bg-foreground/90 hover:scale-105 transition-transform shadow-xl lg:w-auto">
              <Link to={iosLink} newTab className="flex items-center gap-4 px-6">
                <Apple className="size-8" />
                <div className="flex flex-col items-start text-left">
                  <span className="text-xs font-medium opacity-80">
                    Download in de
                  </span>
                  <span className="text-lg font-bold leading-tight">
                    App Store
                  </span>
                </div>
              </Link>
            </Button>
          </div>

          {}
          <div className={`order-1 relative w-64 sm:w-80 lg:order-2 lg:w-96 transition-all duration-1000 delay-100 ${isVisible ? "translate-y-0 opacity-100 scale-100" : "translate-y-20 opacity-0 scale-95"}`}>
            {}
            <div className="absolute -inset-4 z-0 rounded-[3rem] border border-primary/20 bg-primary/5 blur-xl" />
            
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586523/img/zapgo_iphone_3d_mockup.png" alt="ZapGO! App Interface" className="relative z-10 h-auto w-full drop-shadow-2xl transition-transform duration-700 hover:-translate-y-4" />
          </div>

          {}
          <div className={`order-3 flex w-full justify-center lg:w-auto lg:justify-start transition-all duration-1000 delay-300 ${isVisible ? "translate-x-0 opacity-100" : "translate-x-10 opacity-0"}`}>
            <Button asChild size="lg" variant="outline" className="h-16 w-full max-w-[280px] rounded-2xl border-2 border-border bg-background/50 backdrop-blur-sm hover:bg-accent hover:text-accent-foreground hover:scale-105 transition-transform shadow-xl lg:w-auto">
              <Link to={androidLink} newTab className="flex items-center gap-4 px-6">
                <Play className="size-8 text-primary" />
                <div className="flex flex-col items-start text-left">
                  <span className="text-xs font-medium opacity-80">
                    Ontdek het op
                  </span>
                  <span className="text-lg font-bold leading-tight">
                    Google Play
                  </span>
                </div>
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}